/** Shared transition style for smooth bg and text color */
export const transition = 'background-color 1.2s ease-in-out 0s, color 500ms ease -100ms';
/**
 * Shared alternating row styles for tables.
 */
export const alternatingRow = theme => {
    const { palette } = theme || {};
    return {
        odd: palette === null || palette === void 0 ? void 0 : palette.neutralLighterAlt,
        even: palette === null || palette === void 0 ? void 0 : palette.white,
    };
};
/**
 * Shared field sizes for text fields and form controls.
 */
export const FieldSizes = {
    /** Form field width for narrow items. */
    short: 340,
    /** Form field width for multiline textfield items. */
    multiline: 752,
    /** Form field width for wide items. */
    text: 580,
};
